import { ProspectLayers } from '../../components/LayersComponents/ProspectLayers'
import { connectProspectLayers } from '../../components/HOCComponents/connectProspectLayers'

export const ProspectLayersContainer = connectProspectLayers(ProspectLayers)
